import withNavbars from "hoc/withNavbar";
import { Box } from "@mui/material";
import TopWriteNewsContainer from "./TopWriteNewsContainer";
import RichTextContainer from "./RichTextContainer";
import OptionsSideBar from "./OptionsSideBar";
import { useCreateNews } from "hooks/useCreateNews";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateForm } from "utils/validateForm";
import { INews } from "types/News";
import { useToast } from "components/common/Toast/useToast";
import { useTranslate } from "hooks/useTranslate";
import { setThingsState } from "redux/thingsToPublish.slice";
import { useDispatch } from "react-redux";

const WriteNews = () => {
  const [formData, setFormData] = useState<INews>({
    SK: 0,
    title: "",
    description: "",
    body: "",
    sectionId: "",
  });
  const [previewNew, setPreviewNew] = useState<INews>({
    SK: 0,
    sectionName: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { errorToast } = useToast();
  const { translateError } = useTranslate();
  const dispatch = useDispatch();

  const { addNews, loading } = useCreateNews({
    onSuccess: () => navigate("/"),
    onError: (e) => {
      errorToast(
        translateError(Array.isArray(e.message) ? e.message[0] : e.message)
      );
    },
  });

  const handlePreview = () => {
    validateForm(
      [
        {
          key: "section",
          value: formData.sectionId,
        },
        {
          key: "title",
          value: formData.title,
        },
        {
          key: "description",
          value: formData.description,
        },
        {
          key: "image",
          value: formData.featureImageUrl,
        },
      ],
      {
        onSuccess: () => {
          localStorage.setItem(
            "previewNews",
            JSON.stringify({
              title: formData.title,
              body: formData.body,
              description: formData.description,
              featureImageUrl: formData.featureImageUrl,
              sectionName: previewNew.sectionName,
            })
          );
          window.open("vista-previa", "_blank");
        },
        onError: (e: Record<string, string>) => setErrors(e),
      }
    );
  };

  const uploadNews = () => {
    validateForm(
      [
        {
          key: "section",
          value: formData?.sectionId,
        },
        {
          key: "title",
          value: formData?.title,
        },
        {
          key: "description",
          value: formData?.description,
        },
        {
          key: "image",
          value: formData?.featureImageUrl,
        },
      ],
      {
        onSuccess: async () =>
          await (addNews(formData),
          dispatch(setThingsState({ thingsToPublish: true }))),
        onError: (e: Record<string, string>) => setErrors(e),
      }
    );
  };

  const setPreviewData = (key: string, value: any) => {
    setPreviewNew((state: INews) => ({
      ...state,
      [key]: value,
    }));
  };

  const setNewsData = (key: string, value: any) => {
    setFormData((state: INews) => ({
      ...state,
      [key]: value,
    }));
  };

  return (
    <Box height="100%" width="100%" display="flex" gap="24px">
      <Box
        display="flex"
        flexDirection="column"
        gap="24px"
        height="100%"
        width="100%"
      >
        <TopWriteNewsContainer
          mode="add"
          newsData={formData}
          setNewsData={setNewsData}
          errors={errors}
        />
        <RichTextContainer
          newsData={formData}
          uploadNews={() => uploadNews()}
          setNewsData={setNewsData}
          isLoading={loading}
          handlePreview={handlePreview}
        />
      </Box>
      <OptionsSideBar
        newsData={formData}
        setNewsData={setNewsData}
        setPreviewData={setPreviewData}
        errors={errors}
      />
    </Box>
  );
};

export default withNavbars(WriteNews);
